var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"indicator",style:({ width: _vm.percent + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }